import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Box } from '../page/box/box';
import { Paginacaobox } from '../page/box/paginacaoBox';

@Injectable({
  providedIn: 'root'
})
export class BoxService {

  apiURL: string = environment.apiBaseUrl + 'box';

  constructor(private http: HttpClient) { }

  save(box: Box): Observable<Box> {
    return this.http.post<Box>(this.apiURL, box);
  }

  list(page: number, size: number): Observable<Paginacaobox> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(box: Box): Observable<any> {
    return this.http.put<Box>(`${this.apiURL}/${box.id}`, box);
  }

  findClientById(id: number): Observable<Box> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<Box> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }
  
  listarBoxAtivo(): Observable<any> {
    return this.http.get<any>(`${this.apiURL}/listar`);
  }

  listarTodos(): Observable<any> {
    return this.http.get<any>(`${this.apiURL}/listarTodos`);
  }

}